import { useEffect, useRef, useState } from "react";
import api from "../../../../../../services/api";

interface UseLogHistoricoParams<T> {
    itemId?: number;
    isExpanded?: boolean;
    mapearDados: (logs: any[]) => T;
    dadosVazios: T;
}

interface UseLogHistoricoRetorno<T> {
    dados: T | null;
    loading: boolean;
    jaCarregou: boolean;
}

export function useLogHistorico<T>({ itemId, isExpanded, mapearDados, dadosVazios }: UseLogHistoricoParams<T>): UseLogHistoricoRetorno<T> {
    const [dados, setDados] = useState<T | null>(null);
    const [loading, setLoading] = useState(false);
    const [jaCarregou, setJaCarregou] = useState(false);
    const dadosPadrao = useRef(dadosVazios);
    const mapearDadosRef = useRef(mapearDados);

    useEffect(() => {
        mapearDadosRef.current = mapearDados;
    }, [mapearDados]);

    useEffect(() => {
        if (!isExpanded || jaCarregou) {
            return;
        }

        if (!itemId) {
            setDados(dadosPadrao.current);
            setJaCarregou(true);
            setLoading(false);
            return;
        }

        const buscar = async () => {
            try {
                setLoading(true);
                const response = await api.get(`log-historico/${itemId}`);

                const logs = response.data?.result || [];
                const dadosProcessados = mapearDadosRef.current(logs);
                setDados(dadosProcessados);
                setJaCarregou(true);
            } catch (error) {
                setDados(dadosPadrao.current);
            } finally {
                setLoading(false);
            }
        };

        buscar();
    }, [isExpanded, itemId, jaCarregou]);

    return { dados, loading, jaCarregou };
}

